import { Controller } from "@hotwired/stimulus"

// Dashboard "enable fingerprint login on this device?" banner — shown once,
// only on a mobile device with a platform authenticator available (Touch
// ID / Face ID / Android fingerprint), and only while
// Customer#passkey_promptable? is true (server-rendered eligibility, see
// dashboard/overviews/show.html.erb). The registration ceremony itself is
// handled by the composed `webauthn` controller on the same element
// (data-controller="webauthn passkey-prompt", with
// data-webauthn-navigate-on-success-value="false"); this controller only
// owns revealing/hiding the banner and recording a decline.
export default class extends Controller {
  static values = { eligible: Boolean, dismissUrl: String }

  async connect() {
    if (!this.eligibleValue) return
    if (!this._isMobile()) return
    if (!(await this._hasPlatformAuthenticator())) return

    this.element.classList.remove("hidden")
  }

  decline() {
    this.element.classList.add("hidden")
    this._dismiss()
  }

  // Bound to webauthn:registered, dispatched by the composed `webauthn`
  // controller once a passkey is successfully registered.
  handleRegistered() {
    this.element.classList.add("hidden")
  }

  // Private

  _isMobile() {
    return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
  }

  async _hasPlatformAuthenticator() {
    if (!window.PublicKeyCredential?.isUserVerifyingPlatformAuthenticatorAvailable) return false
    return PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().catch(() => false)
  }

  _dismiss() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.dismissUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": token, "X-Requested-With": "XMLHttpRequest" },
      keepalive: true
    }).catch(() => {})
  }
}
